import { itemsFromBackend, itemsFromBackend2, itemsFromBackend3 } from 'app/constants/policies';
import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

const initialState = {
  columnsFromBackend4: {
    [uuidv4()]: {
      name: 'n0',
      title: 'Not Classified',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: [...itemsFromBackend, ...itemsFromBackend3],
      id: uuidv4(),
    },
  },
  columnsFromBackend: {
    [uuidv4()]: {
      name: 'n0',
      title: 'Not Classified',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: itemsFromBackend,
    },
    [uuidv4()]: {
      name: 'n1',
      title: 'Mattlig skada',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: [],
    },
    [uuidv4()]: {
      name: 'n2',
      title: 'Betydande skada',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: [],
    },
    [uuidv4()]: {
      name: 'n3',
      title: 'Allvalig skada',
      describe: 'LoremIpsum ipsum lorem fifth',

      items: [],
    },
    [uuidv4()]: {
      name: 'n4',
      title: 'Skada for rikets sakerhet',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: [],
    },
  },
  columnsFromBackend2: {
    [uuidv4()]: {
      name: 'n0',
      title: 'Not Classified',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: itemsFromBackend,
    },
    [uuidv4()]: {
      name: 'n1',
      title: 'Mattlig skada',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: [],
    },
    [uuidv4()]: {
      name: 'n2',
      title: 'Betydande skada',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: itemsFromBackend2,
    },
    [uuidv4()]: {
      name: 'n3',
      describe: 'LoremIpsum ipsum lorem fifth',
      title: 'Allvalig skada',
      items: [],
    },
    [uuidv4()]: {
      name: 'n4',
      title: 'Skada for rikets sakerhet',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: [],
    },
  },
  columnsFromBackend3: {
    [uuidv4()]: {
      name: 'n0',
      title: 'Not Classified',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: [],
    },
    [uuidv4()]: {
      name: 'n1',
      title: 'Mattlig skada',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: [],
    },
    [uuidv4()]: {
      name: 'n2',
      title: 'Betydande skada',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: itemsFromBackend2,
    },
    [uuidv4()]: {
      name: 'n3',
      title: 'Allvalig skada',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: [],
    },
    [uuidv4()]: {
      name: 'n4',
      title: 'Skada for rikets sakerhet',
      describe: 'LoremIpsum ipsum lorem fifth',
      items: itemsFromBackend3,
    },
  },
};
export const boardColumnSlice = createSlice({
  name: 'activePolicy',
  initialState,
  reducers: {
    createColumn(state, { payload }) {
      state.columnsFromBackend4 = { ...state.columnsFromBackend4, ...payload };
    },

    createColumnGdpr(state, { payload }) {
      state.columnsFromBackend = { ...state.columnsFromBackend, ...payload };
    },

    createColumnXyz(state, { payload }) {
      state.columnsFromBackend2 = { ...state.columnsFromBackend2, ...payload };
    },

    createColumnAbc(state, { payload }) {
      state.columnsFromBackend3 = { ...state.columnsFromBackend3, ...payload };
    },

    editColumn(state, { payload }) {
      state.columnsFromBackend4 = payload;
    },

    editColumnGdpr(state, { payload }) {
      state.columnsFromBackend = payload;
    },

    editColumnXyz(state, { payload }) {
      state.columnsFromBackend2 = payload;
    },
    editColumnAbc(state, { payload }) {
      state.columnsFromBackend3 = payload;
    },
    deleteColumn(state, { payload }) {
      state.columnsFromBackend4 = payload;
    },

    reset: () => initialState,
  },
});

export const {
  createColumn,
  createColumnGdpr,
  createColumnXyz,
  createColumnAbc,
  editColumn,
  editColumnGdpr,
  editColumnXyz,
  editColumnAbc,
  deleteColumn,
  reset,
} = boardColumnSlice.actions;
export default boardColumnSlice.reducer;
